<template>
    <div class="flex flex-col w-full mb-8">
        <p class="text-white" v-if="events.length === 0">
            {{ $t('search.event_empty') }}
        </p>

        <router-link
            v-for="event in sortedEvents" :key="event.name" class="event-contain"
            :to="{name: 'event.view', params: {id: event.id, slug: event.slug}}"
        >
            <img :src="event.cover.cached_url" class="preview-image" :alt="event.name"/>
            <div class="event-infos">
                <div class="flex items-center">
                    <span class="block min-w-[135px] text-white opacity-50">
                        {{ formatDate(event.starting_date) }}
                    </span>
                    <span class="block text-white capitalize">
                        {{ event.name }}
                    </span>
                </div>
                <svg class="shrink-0" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.7999 1.19995H6.39995M10.7999 1.19995V5.59995M10.7999 1.19995L1.19995 10.8" stroke="white"/>
                </svg>
            </div>
        </router-link>
    </div>
</template>
<script>
import TransitionFade from "../../../transitions/TransitionFade.vue"
import TransitionFadeShort from "../../../transitions/TransitionFadeShort.vue";
import {formatDate} from "../../../utils/formatDate";

export default {
    name: 'MoleculeEventList',
    methods: {formatDate},
    components: {TransitionFadeShort, TransitionFade},
    props: {
        events: null
    },
    computed: {
        sortedEvents() {
            return this.events.slice().sort((a, b) => new Date(b.starting_date) - new Date(a.starting_date));
        }
    }
}
</script>
<style>
.event-contain{
    @apply relative hover:bg-pink justify-end flex;
    transition: background-color 0.4s;
}

.event-contain:hover .preview-image {
    opacity: 1;
    z-index: 2;
}

.event-infos {
    @apply flex items-center w-full lg:w-[80%] p-4 justify-between text-left gap-4 border-b border-white border-opacity-20 cursor-pointer;
}

.preview-image {
    @apply h-56 w-[170px] hidden lg:block opacity-0 absolute left-[4%] top-1/2 transform -translate-y-1/2 object-cover;
    z-index: -1;
    transition: opacity 0.2s;
}
</style>
